import zenscroll from 'zenscroll';

export const scrollTo = (offset = 0, duration = 250) => zenscroll.toY(offset, duration);
export const scrollTop = (duration = 250) => scrollTo(0, duration);

export const isScrolledTop = () => window.scrollY === 0;
